import getCurrencySymbol from 'currency-symbol-map'

export function getSymbolFromCurrency(currencyCode: string): string {
  return getCurrencySymbol(currencyCode) || currencyCode
}


/**
 * Format a number to a tiny french number with abbreviations
 *
 * @export
 * @param {number} value
 * @param {number} [decimalPlaces=2]
 * @return {*}  {string}
 */
export function formatToTinyFrenchNumber(value: number | null | undefined, decimalPlaces?: number): string {
  // Handle special cases
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return '0,00';
  }

  const absValue = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  // For extremely large numbers (> 10^15), use scientific notation
  if (absValue >= 1e15) {
    return sign + absValue.toExponential(2).replace('.', ',').replace('e+', ' × 10^');
  }

  // Define French abbreviations
  const abbreviations = [
    { value: 1e9, suffix: ' Mds' },  // Billions (French: milliards)
    { value: 1e6, suffix: ' M' },    // Millions
    { value: 1e3, suffix: ' k' },    // Thousands (French: milliers)
  ];

  // Find appropriate abbreviation
  for (const { value: threshold, suffix } of abbreviations) {
    if (absValue >= threshold) {
      const abbreviated = absValue / threshold;
      const formatted = abbreviated.toLocaleString('fr-FR', {
        minimumFractionDigits: decimalPlaces ?? (abbreviated >= 100 ? 0 : (abbreviated >= 10 ? 1 : 2)),
        maximumFractionDigits: decimalPlaces ?? (abbreviated >= 100 ? 0 : (abbreviated >= 10 ? 1 : 2)),
      });
      return sign + formatted + suffix;
    }
  }

  // For smaller numbers, use standard formatting
  return value.toLocaleString('fr-FR', {
    minimumFractionDigits: decimalPlaces ?? (absValue >= 100 ? 0 : (absValue >= 10 ? 1 : 2)),
    maximumFractionDigits: decimalPlaces ?? (absValue >= 100 ? 0 : (absValue >= 10 ? 1 : 2)),
  });
};

export function formatToFrenchNumber(value: number): string {
  return new Intl.NumberFormat('fr-FR').format(value);
}

/**
 * Formats a performance percentage value (fr-FR) without the "%" suffix.
 * Uses extra decimal places when |value| is below 1 so small moves are not rounded to 0.
 */
export function formatPerformancePercentNumber(value: number): string {
  const abs = Math.abs(value)
  const maximumFractionDigits = abs < 1 ? 2 : abs < 10 ? 1 : 0
  return new Intl.NumberFormat('fr-FR', {
    signDisplay: 'exceptZero',
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(value)
}

export function formatFilteredStockCountSummary(filteredStockCount: number, totalStockCount: number): string {
  const percentage = totalStockCount > 0
    ? ((filteredStockCount / totalStockCount) * 100).toFixed(1)
    : '0.0'

  return `${filteredStockCount} actions filtrées sur ${totalStockCount} (${percentage}%)`
}
